import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack } from "@mui/material";
import type { FC } from "react";
import { useState } from "react";
import AsyncLoadingButton from "../../components/asyncLoadingButton/AsyncLoadingButton";
import LocalFilePicker from "../../components/associatedFiles/LocalFilePicker";

interface Props {
  readonly title: string;
  readonly open: boolean;
  readonly onClose: () => void;
  readonly onNewFile: (formData: FormData) => void | Promise<void>;
}

const ImportCustomersDialog: FC<Props> = ({ title, open, onClose, onNewFile }) => {
  const [file, setFile] = useState<File | undefined>(undefined);
  const [filename, setFilename] = useState("");

  const handleChangeFile = (file?: File) => {
    setFilename(file?.name ?? "");
    setFile(file);
  };

  const handleAdd = async () => {
    if (!file) {
      return;
    }
    const formData = new FormData();
    formData.append("file", file, file.name);
    formData.append("name", filename);
    await onNewFile(formData);
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Stack
          spacing={2}
          sx={{
            minWidth: "400px",
            marginTop: 1,
          }}
        >
          <LocalFilePicker label="Plik CSV" accept="application/csv" onFileChange={handleChangeFile} />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button color="secondary" onClick={onClose}>
          Anuluj
        </Button>
        <AsyncLoadingButton color="primary" disabled={!file} onClick={handleAdd}>
          Importuj
        </AsyncLoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default ImportCustomersDialog;
